import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Script from 'react-load-script';
import graphql from 'graphql';

import Header from '../components/Header';
import Footer from '../components/Footer';
import SidebarMenu from '../components/SidebarMenu';

import '../assets/styles/main.sass';

class TemplateWrapper extends React.Component {
  handleScriptLoad() {
    if (typeof window !== `undefined` && window.netlifyIdentity) {
      window.netlifyIdentity.on('init', user => {
        if (!user) {
          window.netlifyIdentity.on('login', () => {
            document.location.href = '/admin/';
          });
        }
      });
    }
    window.netlifyIdentity.init();
  }

  renderScript() {
    return (
      <Script
        url="https://identity.netlify.com/v1/netlify-identity-widget.js"
        onLoad={() => this.handleScriptLoad()}
      />
    );
  }

  render() {
    return (
      <div>
        <Helmet title="DUKIM s.r.o." />

        {this.renderScript()}

        <SidebarMenu
          links={this.props.data.allMarkdownRemark.edges.map(x => {
            return {
              href: x.node.frontmatter.path,
              title: x.node.frontmatter.title
            };
          })}
        />

        <div className="pageWrapper">
          <a href="#" className="closeLayer" />

          <div className="headerWrapper">
            <div className="container">
              <Header logo={this.props.logo} />
            </div>
          </div>

          <div className="mainContentWrapper">
            <div className="container">{this.props.children()}</div>
          </div>

          <div className="footerWrapper">
            <div className="container">
              <Footer />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export const pageQuery = graphql`
  query AllPagesList {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___title] }) {
      edges {
        node {
          frontmatter {
            path
            title
          }
        }
      }
    }
  }
`;

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js